/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
type AggregatesListingCard_listing$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type AggregatesListingsSimilarItems_aggregatesListings$ref: FragmentReference;
declare export opaque type AggregatesListingsSimilarItems_aggregatesListings$fragmentType: AggregatesListingsSimilarItems_aggregatesListings$ref;
export type AggregatesListingsSimilarItems_aggregatesListings = {|
  +similarItems: ?$ReadOnlyArray<{|
    +$fragmentRefs: AggregatesListingCard_listing$ref
  |}>,
  +$refType: AggregatesListingsSimilarItems_aggregatesListings$ref,
|};
export type AggregatesListingsSimilarItems_aggregatesListings$data = AggregatesListingsSimilarItems_aggregatesListings;
export type AggregatesListingsSimilarItems_aggregatesListings$key = {
  +$data?: AggregatesListingsSimilarItems_aggregatesListings$data,
  +$fragmentRefs: AggregatesListingsSimilarItems_aggregatesListings$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AggregatesListingsSimilarItems_aggregatesListings",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AggregatesListing",
      "kind": "LinkedField",
      "name": "similarItems",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AggregatesListingCard_listing"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AggregatesListingConnectionConnection",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'bae895be317aacede9d1d1280b19003c';

export default node;
